export default __webpack_public_path__ + "static/media/backArrow.f78325e2.svg";